import { produce } from 'immer';

export const spread = produce(Object.assign);
